import { useQuery } from "@tanstack/react-query";
import { AITerms } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const defaultState = {
  accepted: null,
  acceptanceDetails: null,
  terms: null
};
const getAcceptanceState = () => AITerms.acceptance().then(
  (state) => ({
    ...state,
    acceptanceDetails: state.acceptance_details
  }),
  (error) => {
    var _a, _b;
    if (error.status === 409) {
      return defaultState;
    }
    return {
      ...defaultState,
      error: (_b = (_a = error == null ? void 0 : error.responseMessage) != null ? _a : error == null ? void 0 : error.message) != null ? _b : "Fetching Terms Acceptance state failed for unknown reason."
    };
  }
);
const useAITermsAcceptance = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["investigation-ai-acceptance-by-user"],
    queryFn: () => defaultOnError(
      getAcceptanceState(),
      "Fetching acceptance status failed with status",
      "Could not fetch acceptance status"
    ),
    gcTime: 0
  });
  return {
    data: data != null ? data : defaultState,
    isLoading,
    refetch
  };
};
export default useAITermsAcceptance;
